/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
import { GenealogySource, Parent } from "../Genealogy/types";

let sources: GenealogySource[];

const getSource = (id: string): GenealogySource[] => {
  return sources.filter((s) => s.id === id);
};

const getSources = (ids: string[]): GenealogySource[] => {
  return sources.filter((source) => ids.filter((id) => source.id === id).length > 0);
};

export const getLadageParents = (genSources: GenealogySource[]): Parent[] => {
  sources = genSources;

  const parents = [];
  // Generation 1
  parents.push({
    name: "Nicolaus La Dague",
    birth: {
      date: "1438",
    },
    mariages: [
      {
        children: [
          {
            name: "Steeve La Dague",
            birth: {
              date: "1463",
            },
            mainAncestor: true,
          },
        ],
      },
    ],
  } as Parent);

  // Generation 2
  parents.push({
    name: "Steeve La Dague",
    birth: {
      date: "1463",
      city: "Sedan",
    },
    mariages: [
      {
        partner: {
          name: "Estherine Goutterbarge",
          birth: {
            date: "1466",
            city: "Valmer",
          },
        },
        date: "10-10-1487",
        children: [
          {
            name: "Abraham La Dague",
            birth: {
              date: "1492",
            },
            mainAncestor: true,
          },
        ],
      },
    ],
    death: {
      date: "1518",
      city: "Sedan",
    },
  } as Parent);

  // Generation 3
  parents.push({
    name: "Abraham La Dague",
    birth: {
      date: "1492",
    },
    mariages: [
      {
        partner: {
          name: "Louisa Bouchaer",
          birth: {
            date: "1495",
          },
          death: {
            date: "1564",
          },
        },
        date: "01-12-1522",
        children: [
          {
            name: "Nicolas La Dague",
            birth: {
              date: "25-08-1523",
              city: "Sedan",
            },
            mainAncestor: true,
          },
        ],
      },
    ],
  } as Parent);

  // Generation 4
  parents.push({
    name: "Nicolas La Dague",
    birth: {
      date: "25-08-1523",
      city: "Sedan",
    },
    mariages: [
      {
        partner: {
          name: "Sara Lacroix",
          birth: {
            date: "01-10-1529",
            city: "Sedan",
          },
        },
        date: "07-04-1550",
        city: "Sedan",
        children: [
          {
            name: "Pierre La Dague",
            birth: {
              date: "14-06-1559",
              city: "Sedan",
            },
            mainAncestor: true,
          },
          {
            name: "Agatha La Dague",
            birth: {
              date: "18-08-1560",
              city: "Sedan",
            },
          },
        ],
      },
    ],
  } as Parent);

  // Generation 5
  parents.push({
    name: "Pierre La Dague",
    backgroundInfo: {
      text: "Pierre was 'Sergetier'. De sergetier was een vakman die werkte met serge, wol en andere stoffen. Hij was een soort van kleermaker dus.",
    },
    birth: {
      date: "14-06-1559",
      city: "Sedan",
    },
    mariages: [
      {
        partner: {
          name: "Marie Loyson",
        },
        date: "04-09-1583",
        city: "Sedan",
        sources: getSource("1583FRHA"),
        children: [
          {
            name: "Eve La Dague",
            birth: {
              date: "14-03-1584",
              city: "Sedan",
            },
            baptism: {
              date: "18-03-1584",
              city: "Sedan",
              sources: getSource("1584FRGA"),
            },
          },
          {
            name: "Abraham La Dague",
            birth: {
              date: "30-11-1585",
              city: "Sedan",
            },
            baptism: {
              date: "08-12-1585",
              city: "Sedan",
              sources: getSource("1585FRGA"),
            },
            death: {
              date: "11-06-1641",
              city: "Sedan",
            },
            mainAncestor: true,
          },
          {
            name: "Jacques La Dague",
            baptism: {
              date: "04-10-1587",
              city: "Sedan",
              sources: getSource("1587WFGA"),
            },
            death: {
              date: "10-11-1602",
              city: "Sedan",
              sources: getSource(""),
            },
          },
        ],
      },
    ],
  } as Parent);

  // Generation 6
  parents.push({
    name: "Abraham La Dague",
    backgroundInfo: {
      text: "Abraham was timmerman van beroep, maar ook wapenmaker en soldaat.",
    },
    birth: {
      date: "30-11-1585",
      city: "Sedan",
    },
    baptism: {
      date: "08-12-1585",
      city: "Sedan",
      sources: getSource("1585FRGA"),
    },
    death: {
      date: "11-06-1641",
      city: "Sedan",
    },
    mariages: [
      {
        partner: {
          name: "Anne Camuset",
          birth: {
            date: "1593",
            sources: getSource("1633FROA"),
          },
          death: {
            date: "03-11-1633",
            city: "Sedan",
            sources: getSource("1633FROA"),
          },
        },
        date: "1631",
        children: [
          {
            name: "Louis La Dague",
            birth: {
              date: "1633",
            },
            death: {
              date: "29-05-1687",
              city: "Sedan",
            },
            mainAncestor: true,
          },
        ],
      },
      {
        partner: {
          name: " Marthe Perin",
          death: {
            date: "20‑01‑1668",
            city: "Sedan",
            sources: getSource("1668FROA"),
          },
        },
        date: "03-09-1634",
        city: "Sedan",
        sources: getSource("1634FRHA"),
        children: [
          {
            name: "Louis La Dague",
            birth: {
              date: "16-04-1635",
              city: "Sedan",
              sources: getSource("1635FRGA2"),
            },
            baptism: {
              date: "19-04-1635",
              city: "Sedan",
              sources: getSource("1635FRGA2"),
            },
            death: {
              date: "29-07-1636",
              city: "Sedan",
              sources: getSource("1636FROA"),
            },
          },
          {
            name: "Pierre La Dague",
            birth: {
              date: "13-05-1638",
              city: "Sedan",
              sources: getSource("1638FRGA"),
            },
            baptism: {
              date: "16-05-1638",
              city: "Sedan",
              sources: getSource("1638FRGA"),
            },
          },
        ],
      },
    ],
  });

  // Generation 7
  parents.push({
    name: "Louis La Dague",
    backgroundInfo: {
      text: "Louis was schoenmaker in Sedan. Uit de aktes is het niet heel erg duidelijk, maar zeer waarschijnlijk waren er twee kinderen van Abraham La Daque die 'Louis' heetten. Het eerste kind was een kind van Anna Camuset (getuige de huwelijksakte met Esther Guitaine) en dat is dus deze Louis. De andere Louis was een kind van Marte Perin (alsus het doopregister) en stierf kort na de geboorte in 1636 (te lezen in de overlijdensakte).",
    },
    birth: {
      date: "1633",
    },
    death: {
      date: "29-05-1687",
      city: "Sedan",
    },
    mariages: [
      {
        partner: {
          name: "Esther Guitaine",
          birth: {
            date: "08-04-1635",
            city: "Sedan",
            sources: getSource("1635FRGA"),
          },
          baptism: {
            date: "15-04-1635",
            city: "Sedan",
            sources: getSource("1635FRGA"),
          },
        },
        date: "20-09-1654",
        city: "Sedan",
        sources: getSource("1654FRHA"),
        children: [
          {
            name: "Claude La Dague",
            birth: {
              date: "13-08-1656",
              city: "Sedan",
              sources: getSource("1656FRGA"),
            },
            baptism: {
              date: "15-08-1656",
              city: "Sedan",
              sources: getSource("1656FRGA"),
            },
          },
          {
            name: "Pierre La Dague",
            birth: {
              date: "14-08-1658",
              city: "Sedan",
              sources: getSource("1658FRGA"),
            },
            baptism: {
              date: "17-08-1658",
              city: "Sedan",
              sources: getSource("1658FRGA"),
            },
            mainAncestor: true,
          },
          {
            name: "Marie La Dague",
            birth: {
              date: "31-08-1660",
              city: "Sedan",
              sources: getSource("1660FRGA"),
            },
            baptism: {
              date: "12-09-1660",
              city: "Sedan",
              sources: getSource("1660FRGA"),
            },
          },
          {
            name: "Charlotte La Dague",
            birth: {
              date: "23-03-1662",
              city: "Sedan",
              sources: getSource("1662FRGA"),
            },
            baptism: {
              date: "26-03-1662",
              city: "Sedan",
              sources: getSource("1662FRGA"),
            },
          },
          {
            name: "Susanne La Dague",
            birth: {
              date: "04-02-1664",
              city: "Sedan",
              sources: getSource("1664FRGA"),
            },
            baptism: {
              date: "10-02-1664",
              city: "Sedan",
              sources: getSource("1664FRGA"),
            },
          },
          {
            name: "Jaques La Dague",
            birth: {
              date: "06-11-1666",
              city: "Sedan",
              sources: getSource("1666FRGA"),
            },
            baptism: {
              date: "10-11-1666",
              city: "Sedan",
              sources: getSource("1666FRGA"),
            },
          },
          {
            name: "Madelaine La Dague",
            baptism: {
              date: "05-03-1669",
              city: "Sedan",
              sources: getSource("1669FRGA"),
            },
            burrial: {
              date: "07-09-1670",
              city: "Sedan",
              sources: getSource("1670FROA"),
            },
          },
          {
            name: "Jean La Dague",
            baptism: {
              date: "13-11-1670",
              city: "Sedan",
              sources: getSource("1670FRGA"),
            },
            burrial: {
              date: "28-07-1674",
              city: "Sedan",
              sources: getSource("1674FROA"),
            },
          },
          {
            name: "Rachel La Dague",
            baptism: {
              date: "28-08-1672",
              city: "Sedan",
              sources: getSource("1672FRGA"),
            },
          },
          {
            name: "Etienne La Dague (noemt zichzelf later Steven de Ladake)",
            baptism: {
              date: "05-11-1673",
              city: "Sedan",
              sources: getSource("1673FRGA"),
            },
          },
          {
            name: "Sara La Dague",
            baptism: {
              date: "14-12-1675",
              city: "Sedan",
              sources: getSource("1675FRGA"),
            },
            burrial: {
              date: "12-08-1679",
              city: "Sedan",
              sources: getSource("1679FROA"),
            },
          },
          {
            name: "Daniel La Dague",
            baptism: {
              date: "21-08-1678",
              city: "Sedan",
              sources: getSource("1678FRGA"),
            },
            burrial: {
              date: "22-08-1678",
              city: "Sedan",
              sources: getSource("1678FROA"),
            },
          },
          {
            name: "Anne La Dague",
            baptism: {
              date: "01-11-1682",
              city: "Sedan",
              sources: getSource("1682FRGA"),
            },
          },
        ],
      },
    ],
  });

  // Generation 8
  parents.push({
    name: "Pierre La Dague",
    backgroundInfo: {
      text: "In de huwelijksakte is een bijschrift te lezen '1, 2, 3, prononce sans aucun aucun empêchement', wat zoiets betekend als '1, 2, 3 uitgesproken zonder enige belemmering'.",
    },
    birth: {
      date: "14-08-1658",
      city: "Sedan",
      sources: getSource("1656FRGA"),
    },
    mariages: [
      {
        partner: {
          name: "Anne George Ferme",
        },
        date: "22-06-1681",
        city: "Den Haag",
        sources: getSource("1681TWHU"),
        children: [
          {
            name: "Paulus Ladage",
            birth: {
              date: "01-04-1683",
              city: "Den Haag",
            },
            baptism: {
              date: "04-04-1683",
              city: "Den Haag",
              sources: getSource("1683DWGA"),
            },
            mainAncestor: true,
          },
          {
            name: "Anthoijne Ladage",
            birth: {
              date: "21-02-1685",
              city: "Den Haag",
            },
            baptism: {
              date: "25-02-1685",
              city: "Den Haag",
              sources: getSource("1685DWGA"),
            },
          },
          {
            name: "Jacques Ladage",
            birth: {
              date: "25-05-1687",
              city: "Den Haag",
            },
            death: {
              date: "10-11-1687",
              city: "Den Haag",
            },
          },
          {
            name: "Jacque Ladage",
            baptism: {
              date: "17-03-1689",
              city: "Den Haag",
              sources: getSource("1689DWGA"),
            },
          },
          {
            name: "Marie Ladage",
            baptism: {
              date: "04-03-1691",
              city: "Den Haag",
              sources: getSource("1691DWGA"),
            },
          },
          {
            name: "Marthe Ladage",
            baptism: {
              date: "03-05-1693",
              city: "Den Haag",
              sources: getSource("1693DWGA"),
            },
          },
          {
            name: "Salmon Ladage",
            baptism: {
              date: "10-07-1695",
              city: "Den Haag",
              sources: getSource("1695DWGA"),
            },
          },
        ],
      },
    ],
  });

  // Generation 9
  parents.push({
    name: "Paulus Ladage",
    backgroundInfo: {
      text: "Paulus was soldaat. Perina wordt in diverse aktes anders genoemd. Zo is haar naam in de doopakte van 1718 nog 'Parina Selsate'. Maar bij de doop van Gerrit 3 jaar later wordt ze 'Perrine Jans' genoemd. Nog opvallender is dat ze in de doopaktes voor 1720 'Selsate' of 'Selsaat' wordt genoemd, in de aktes daarna 'Jans' of 'Janse'. Het lijkt er dus op dat ze bewust haar achternaam heeft veranderd. Wellicht omdat haar achternaam voor Nederlanders moeilijk uit te spreken was. Datzelfde geldt voor Paulus Ladage, die soms ook genoteerd staat als 'Laetdage'.",
    },
    birth: {
      date: "01-04-1683",
      city: "Den Haag",
    },
    baptism: {
      date: "04-04-1683",
      city: "Den Haag",
      sources: getSource("1683DWGA"),
    },
    death: {
      date: "05-06-1730",
      city: "Brielle",
    },
    mariages: [
      {
        partner: {
          name: "Perina Selsate",
          birth: {
            date: "24-07-1683",
            city: "Sluys (Vlaanderen, België)",
          },
          death: {
            date: "09-06-1757",
            city: "Brielle",
          },
        },
        date: "26-04-1705",
        children: [
          {
            name: "Jan Ladage",
            birth: {
              date: "02-12-1706",
              city: "Brielle",
            },
          },
          {
            name: "Isaac Ladage",
            birth: {
              date: "25-08-1710",
              city: "Brielle",
            },
          },
          {
            name: "Josua Ladage",
            birth: {
              date: "07-04-1712",
              city: "Brielle",
            },
            mainAncestor: true,
          },
          {
            name: "Pieter Ladage",
            birth: {
              date: "19-07-1714",
              city: "Brielle",
              sources: getSource("1714SVGA"),
            },
          },
          {
            name: "Johan Ladage",
            birth: {
              date: "28-12-1715",
              city: "Brielle",
              sources: getSource("1716SVGA"),
            },
          },
          {
            name: "Jan Ladage",
            birth: {
              date: "02-02-1718",
              city: "Brielle",
              sources: getSource("1718SVGA"),
            },
          },
          {
            name: "Gerrit Ladage",
            birth: {
              date: "18-02-1720",
              city: "Brielle",
              sources: getSource("1720SVGA"),
            },
          },
          {
            name: "Anna Ladage",
            birth: {
              date: "21-01-1722",
              city: "Brielle",
              sources: getSource("1722SVGA"),
            },
          },
          {
            name: "Arentje Ladage",
            birth: {
              date: "24-01-1724",
              city: "Brielle",
              sources: getSource("1724SVGA"),
            },
          },
        ],
      },
    ],
  });

  // Generation 10
  parents.push({
    name: "Josua Ladage",
    backgroundInfo: {
      text: "Of de vrouw van Josua nu 'Christijnje', 'Stijntje' of nog wat anders is geweest is lastig te zeggen; in diverse aktes wordt haar naam anders geschreven. Ze is na het overlijden van Josua nog 3 maal gehuwd; op 22-08-1752 met Hendrik de Haas, op 13-11-1753 met Jan Houwaart en op 30-10-1759 met Jan Huysman. Josua en Stijntje woonden in Meent, boven het pakhuis van de kooperslager.",
    },
    birth: {
      date: "07-04-1712",
      city: "Brielle",
    },
    death: {
      date: "03-03-1747",
      city: "Rotterdam (Meent)",
    },
    burrial: {
      date: "08-03-1747",
      city: "Rotterdam (Westerkerkhof)",
      sources: getSource("1747GBOA"),
    },
    mariages: [
      {
        partner: {
          name: "Stijntje Stierman",
          birth: {
            date: "01-03-1720",
            city: "Rotterdam",
          },
          baptism: {
            date: "05-03-1720",
            city: "Rotterdam",
            sources: getSource("1720SRGA"),
          },
          death: {
            date: "29-12-1796",
            city: "Rotterdam (Doelstraat)",
          },
          burrial: {
            date: "31-12-1796",
            city: "Rotterdam (Westerkerkhof)",
          },
        },
        date: "09-07-1741",
        children: [
          {
            name: "Klaas Ladage",
            birth: {
              date: "28-06-1741",
              city: "Rotterdam",
            },
          },
          {
            name: "Poulus Ladage",
            mainAncestor: true,
            birth: {
              date: "27-10-1743",
              city: "Rotterdam",
            },
          },
          {
            name: "Pieter Ladage",
            birth: {
              date: "08-08-1745",
              city: "Rotterdam",
            },
          },
        ],
      },
    ],
  });

  // Generation 11
  parents.push({
    name: "Poulus Ladage",
    birth: {
      date: "27-10-1743",
      city: "Rotterdam",
    },
    baptism: {
      date: "31-10-1743",
      city: "Rotterdam (Meent)",
      sources: getSource("1743DRGA"),
    },
    death: {
      date: "27-06-1781",
      city: "Rotterdam (Doelstraat)",
      sources: getSource("1781SRBI"),
    },
    burrial: {
      date: "30-06-1781",
      sources: getSource("1781GBOA"),
    },
    mariages: [
      {
        partner: {
          name: "Wilhelmina van Tiel",
          birth: {
            date: "08-05-1731",
            city: "Rotterdam",
          },

          death: {
            date: "10-11-1813",
            city: "Rotterdam",
          },
        },
        date: "21-01-1766",
        sources: getSource("1766GRHA"),
        children: [
          {
            name: "n.n. Ladage (doodgeboren)",
            birth: {
              date: "28-07-1767",
            },
            death: {
              date: "28-07-1767",
            },
          },
          {
            name: "Joshua Ladage",
            birth: {
              date: "21-12-1768",
              city: "Rotterdam",
            },
            death: {
              date: "07-11-1791",
              city: "Rotterdam",
              sources: getSource("1791SRBI"),
            },
            mainAncestor: true,
          },
          {
            name: "Hendrik Ladage",
            birth: {
              date: "07-02-1771",
              city: "Rotterdam",
            },
          },
          {
            name: "Johannes Ladage",
            baptism: {
              date: "05-06-1774",
              city: "Rotterdam",
              sources: getSource("1774DRGA"),
            },
          },
          {
            name: "n.n. Ladage (doodgeboren)",
            birth: {
              date: "05-01-1777",
            },
            death: {
              date: "05-01-1777",
            },
          },
        ],
      },
    ],
  });

  // Generation 12
  parents.push({
    name: "Josua Ladage",
    backgroundInfo: {
      text: "Wonende aan de Lombardstraat te Rotterdam. Josua was vleeshouwer, Maria was fruitverkoopster. Op 21-02-1796 is Maria Palte hertrouwd met Johannes Antonius Warnaar.",
    },
    birth: {
      date: "21-12-1768",
      city: "Rotterdam",
    },
    baptism: {
      date: "25-12-1768",
      city: "Rotterdam",
      sources: getSource("1768SRGA"),
    },
    death: {
      date: "07-11-1791",
      city: "Rotterdam",
      sources: getSource("1791SRBI"),
    },
    burrial: {
      date: "11-11-1791",
    },
    mariages: [
      {
        partner: {
          name: "Johanna Maria Palte",
          birth: {
            city: "Rotterdam",
          },
          baptism: {
            date: "16-04-1766",
            city: "Rotterdam",
            sources: getSource("1766DRGA"),
          },
        },
        date: "20-04-1790",
        sources: getSource("1790SRHA"),
        children: [
          {
            name: "Paulus Ladage",
            birth: {
              date: "22-06-1790",
              city: "Rotterdam",
              sources: getSource("1790SRNM"),
            },
            mainAncestor: true,
          },
          {
            name: "Fransijnna Ladage",
            birth: {
              date: "18-10-1791",
              city: "Rotterdam",
              sources: getSource("1791DRGA"),
            },
          },
        ],
      },
    ],
  });

  // Generation 13
  parents.push({
    name: "Paulus Ladage",
    backgroundInfo: {
      text: "Paulus Ladage was ten tijde van zijn huwelijk 'Vleeshouwersknecht'. Hij ging in dienst als soldaat.",
    },
    birth: {
      date: "22-06-1790",
      city: "Rotterdam",
      sources: getSource("1790SRNM"),
    },
    baptism: {
      date: "29-06-1790",
      sources: getSource("1790DRGA"),
    },
    death: {
      date: "25-11-1836",
      city: "Gilze",
      sources: getSource("1836RTOA"),
    },
    mariages: [
      {
        partner: {
          name: "Maria Johanna Schlimmer",
          birth: {
            date: "16-04-1798",
            city: "Dordrecht",
          },
          death: {
            date: "23-09-1825",
            city: "Rotterdam",
            sources: getSource("1825SROA"),
          },
        },
        date: "06-05-1818",
        sources: getSource("1818SRHA"),
        children: [
          {
            name: "Johannes Josua Ladage",
            birth: {
              date: "31-12-1818",
              city: "Rotterdam",
            },
            mainAncestor: true,
          },
          {
            name: "Johanna Magdalena Ladage",
            birth: {
              date: "02-03-1822",
              city: "Rotterdam",
              sources: getSource("1822SRGA"),
            },
          },
          {
            name: "n.n. Ladage",
            birth: {
              date: "18-09-1825",
              city: "Rotterdam",
              sources: getSource("1825SRLA"),
            },
            death: {
              date: "18-09-1825",
              city: "Rotterdam",
              sources: getSource("1825SRLA"),
            },
          },
        ],
      },
    ],
  });

  // Generation 14
  parents.push({
    name: "Johannes Josua Ladage",
    backgroundInfo: {
      text: "Johannes Josua Ladage was slager en leesboekverkoper. Hij is eerder getrouwd geweest met Antonetta Espitallier. Dat huwelijk kon hij echter niet betalen getuige de 'verklaring van armoede'. Zoon Gerardus Johannes Ladage krijgt een zoon uit zijn huwelijk met Cornelia Verkerk die later bekend kunstenaar wordt.",
      sources: getSource("1828SRVA"),
    },
    birth: {
      date: "31-12-1818",
      city: "Rotterdam (Botersloot 636)",
      sources: getSource("1818SRGA"),
    },
    death: {
      date: "03-01-1882",
      city: "Rotterdam (Generaal v.d. Heidenstraat)",
      sources: getSource("1882SROA"),
    },
    mariages: [
      {
        partner: {
          name: "Antonetta Espitallier",
          birth: {
            date: "19-04-1819",
            city: "Rotterdam",
            sources: getSource("1850SRVT"),
          },
          death: {
            date: "13-08-1853",
            city: "Rotterdam",
            sources: getSource("1853SROA"),
          },
        },
        date: "29-05-1844",
        sources: getSource("1850SRVT"),
        children: [
          {
            name: "Paulus Gerardus Ladage (erkenning door vader op 29-05-1844)",
            birth: {
              date: "04-12-1841",
              city: "Rotterdam",
              sources: getSource("1841SRGA"),
            },
          },
          {
            name: "Maria Johanna Ladage (erkenning door vader op 29-05-1843)",
            birth: {
              date: "27-11-1843",
              city: "Rotterdam",
              sources: getSource("1843SRGA"),
            },
          },
          {
            name: "Maria Cornelia Ladage",
            birth: {
              date: "02-04-1846",
              city: "Rotterdam",
              sources: getSource("1846SRGA"),
            },
          },
          {
            name: "Gerardus Johannes Ladage",
            birth: {
              date: "24-10-1847",
              city: "Rotterdam",
              sources: getSource("1847SRGA"),
            },
          },
        ],
      },
      {
        partner: {
          name: "Cornelia Helleman",
          birth: {
            date: "11-08-1827",
            city: "Ouderkerk a/d Ijssel",
            sources: getSource("1827SMGA"),
          },
          death: {
            date: "27-04-1905",
            city: "Rotterdam (Houttuin)",
            sources: getSource("1905SROA"),
          },
        },
        date: "27-06-1860",
        sources: getSource("1860SRHA"),
        children: [
          {
            name: "Maria Ladage",
            birth: {
              date: "26-01-1861",
              city: "Rotterdam",
              sources: getSource("1861SRGA"),
            },
          },
          {
            name: "Johannes Josua Ladage",
            birth: {
              date: "18-09-1862",
              city: "Rotterdam",
              sources: getSource("1862SRGA"),
            },
            death: {
              date: "05-12-1863",
            },
          },
          {
            name: "Dirk Ladage",
            birth: {
              date: "15-04-1865",
              city: "Rotterdam",
              sources: getSource("1865SRGA"),
            },
          },
          {
            name: "Lambertina Ladage",
            birth: {
              date: "21-10-1867",
              city: "Rotterdam",
              sources: getSource("1867SRGA"),
            },
          },
          {
            name: "Johannes Jozua Ladage",
            birth: {
              date: "07-02-1870",
              city: "Rotterdam",
              sources: getSource("1870SRGA"),
            },
            mainAncestor: true,
          },
          {
            name: "Cornelia Ladage",
            birth: {
              date: "01-07-1873",
              city: "Rotterdam",
              sources: getSource("1873SRGA"),
            },
          },
        ],
      },
    ],
  });

  // Generation 15
  parents.push({
    name: "Johannes Jozua (Joost) Ladage",
    backgroundInfo: { text: "Joost Ladage was suikerwerker en drogist." },
    birth: {
      date: "07-02-1870",
      city: "Rotterdam",
      sources: getSource("1870SRGA"),
    },
    death: {
      date: "01-06-1943",
      city: "Zeist (Kroostweg 19c)",
      sources: getSource("1882SROA"),
    },
    burrial: {
      date: "04-06-1943",
      city: "Zeist (Nieuwe Algemene Begraafplaats)",
    },
    mariages: [
      {
        partner: {
          name: "Wilhelmina Hendrika (Mien) ten Cate",
          birth: {
            date: "03-02-1874",
            city: "Gouda (Kattensingel Q/152)",
            sources: getSource("1874SMGA"),
          },
          death: {
            date: "16-08-1961",
            city: "Doorn (Wilhelminaweg 12)",
            sources: getSource("1961UAOA"),
          },
        },
        date: "21-06-1900",
        sources: getSources(["1900KRKH", "1900SRHA", "1900FRHK1", "1900FRHK2"]),
        children: [
          {
            name: "Hendrik Wilhelm Ladage",
            birth: {
              date: "09-04-1901",
              city: "Rotterdam",
              sources: getSource("1901SRGA"),
            },
            mainAncestor: true,
          },
          {
            name: "Johanna Josephina (Fien) Ladage",
            birth: {
              date: "10-02-1904",
              city: "Rotterdam",
              sources: getSource("1904SRGA"),
            },
          },
          {
            name: "Cornelia Ladage",
            birth: {
              date: "19-01-1905",
              city: "Rotterdam",
              sources: getSource("1905SRGA"),
            },
          },
        ],
      },
    ],
  });

  // Generation 16
  parents.push({
    name: "Hendrik Wilhelm Ladage",
    backgroundInfo: { text: "Hendrik Ladage was boekhouder en drogist, en runde een drogisterij aan de van Citterstraat 19a in Rotterdam." },
    birth: {
      date: "09-04-1901",
      city: "Rotterdam (Boezemsingel)",
      sources: getSource("1901SRGA"),
    },
    death: {
      date: "29-12-1969",
      city: "Rotterdam (van Adrichemweg 56a)",
    },
    burrial: {
      date: "03-01-1970",
      city: "Rotterdam (Hofwijk)",
    },
    mariages: [
      {
        partner: {
          name: "Christina Huygens",
          birth: {
            date: "25-09-1899",
            city: "Rotterdam (Honingerdijk 8316)",
            sources: getSource("1933SRGA"),
          },
          death: {
            date: "16-05-1963",
            city: "Roterdam (van Citterstraat 19a)",
            sources: getSource("1963KROK"),
          },
          burrial: {
            date: "21-05-1963",
            city: "Rotterdam (Hofwijk)",
          },
        },
        date: "05-07-1933",
        sources: getSources(["1933SRHA"]),
        children: [
          {
            name: "Johannes Wilhelm (Joop) Ladage",
            birth: {
              date: "23-10-1938",
              city: "Rotterdam",
            },
            mainAncestor: true,
          },
        ],
      },
    ],
  });

  /**
  Disabled for privacy reasons
  // Generation 16
  parents.push({
    name: "Johannes Wilhelm (Joop) Ladage",
    birth: {
      date: "23-10-1938",
      city: "Rotterdam",
    },
    mariages: [
      {
        partner: {
          name: "Christina (Christine) Schaaf-Bekkers",
          birth: {
            date: "22-05-1937",
            city: "Rotterdam",
          },
        },
        date: "10-06-1970",
        children: [
          {
            name: "Mignon Monique (Mignon) Ladage",
            birth: {
              date: "20-09-1972",
              city: "Ede",
            },
          },
          {
            name: "Ivo Michel (Ivo) Ladage",
            birth: {
              date: "30-06-1974",
              city: "Ede",
            },
            mainAncestor: true,
          },
        ],
      },
    ],
  });


  // Generation 17
  parents.push({
    name: "Ivo Michel (Ivo) Ladage",
    birth: {
      date: "30-06-1974",
      city: "Ede",
    },
    mariages: [
      {
        partner: {
          name: "Elise Maria Irene van Doorn",
          birth: {
            date: "10-03-1977",
            city: "Numansdorp",
          },
        },
        date: "22-04-2008",
        city: "Beuningen",
        children: [
          {
            name: "Mathijs Ruben (Mathijs) Ladage",
            birth: {
              date: "06-02-2011",
              city: "Nijmegen",
            },
            mainAncestor: true,
          },
          {
            name: "Evie Jasmijn (Evie) Ladage",
            birth: {
              date: "27-02-2014",
              city: "Nijmegen",
            },
          },
        ],
      },
    ],
  });

  // Generation 18
  parents.push({
    name: "Mathijs Ruben (Mathijs) Ladage",
    birth: {
      date: "06-02-2011",
      city: "Nijmegen",
    },
  });
  */

  return parents;
};
